<template>

<div align="justify">
    <p class="h4" align="center">Сервисы 1С</p>
    <div align="justify" style="padding: 10px;">
        
        <!--
        <p>
            <strong>Описание</strong>
        </p>
        -->
        <!--{{ contentWidth }}<br>-->
        
        <!--
        <div style="display: table;">
            <div v-for="service in services" v-bind:key="service.id"
                v-bind:style="{'border': '0px solid blue', 'display': 'table', 'width': serviceDiv.width + 'px', 'float': 'left', 'margin-bottom': '10px'}">
                <div v-bind:style="{'border': '0px solid green', 'float': 'left', 'width': '72px', 'height': serviceDiv.height + 'px'}">
                    <a v-bind:href="service.url" target="_blank" rel="noopener" style="color: black;">
                    <img v-bind:src="service.img.src" v-bind:alt="service.title" v-bind:style="{'background-color': service.img.backgroundColor}">
                    </a>
                </div>
                <div v-bind:style="{'border': '0px solid blue', 'display': 'table', 'float': 'left', 'width': (serviceDiv.width - 72) + 'px', 'height': serviceDiv.height + 'px', 'padding-left': '5px', 'padding-right': '25px'}">
                    <div style="float: left; font-weight: bold;">
                        <a v-bind:href="service.url" target="_blank" rel="noopener" style="color: black;">{{ service.title }}</a>
                    </div>
                    <br>
                    <div style="float: left;" v-html="service.description">
                    </div>
                </div>
            </div>
        </div>
        
        <hr>
        -->
        
        <p style="font-size: larger;">
            <!--
            Полный перечень сервисов доступен на сайте <a href="https://portal.1c.ru/" target="_blank" rel="noopener">https://portal.1c.ru/</a>.
            <br>
            -->
            Если возникли вопросы, позвоните нам по номеру <span style="font-weight: bold; color: blue;">8 (8216) 76-33-06</span>
        </p>
        
        <table>
        <div style="display: table;">
            <tr v-for="row in servicesTable" v-bind:key="row.id"
                v-bind:style="{'border': '0px solid blue', 'display': 'table', 'margin-bottom': '10px'}">
                <td v-for="service in row" v-bind:key="service.id"
                    v-bind:style="{'border': '0px solid blue', 'display': 'table', 'width': serviceDiv.width + 'px', 'float': 'left', 'margin-bottom': '10px'}">
                    <div v-bind:style="{'border': '0px solid green', 'float': 'left', 'width': '72px', 'height': serviceDiv.height + 'px'}">
                        <a v-bind:href="service.url" target="_blank" rel="noopener">
                            <img v-bind:src="service.img.src" v-bind:alt="service.title" v-bind:style="{'background-color': service.img.backgroundColor}">
                        </a>
                    </div>
                    <div v-bind:style="{'border': '0px solid blue', 'display': 'table', 'float': 'left', 'width': (serviceDiv.width - 72 - 30) + 'px', 'height': serviceDiv.height + 'px', 'margin-left': '3px', 'margin-right': '10px', 'box-shadow': '0 0 0px rgba(50,50,50,1)'}">
                        <div style="float: left; font-weight: bold; padding-left: 10px;">
                            <a v-bind:href="service.url" target="_blank" rel="noopener" style="color: black;">{{ service.title }}</a>
                        </div>
                        <br>
                        <div style="float: left; padding-left: 10px; padding-right: 10px;" v-html="service.description">
                        </div>
                    </div>
                </td>
            </tr>
        </div>
        </table>
        
    </div>
    
</div>

</template>

<script>
export default {
    name: 'PageContacts',
    data: function(){
        return{
            services: [],
            servicesTable: [],
            serviceDiv: {
                width: 0,
                height: 0
            }
        };
    },
    created: function(){
        
        this.update();
        
    },
    mounted: function(){
        this.windowOnResize();
    },
    computed:{
        httpPath: function(){
            return this.$store.getters.httpPath;
        },
        viewMode: function(){
            return this.$store.getters.viewMode;
        },
        contentWidth: function(){
            return this.$store.getters.contentWidth;
        },
        contentHeight: function(){
            return this.$store.getters.contentHeight;
        }
    },
    watch: {
        contentWidth: function(){
            this.windowOnResize();
        },
        contentHeight: function(){
            this.windowOnResize();
        }
    },
    methods: {
        windowOnResize: function(){
            
            let contentWidth = this.contentWidth - 30;
            
            this.serviceDiv.width = contentWidth;
            this.serviceDiv.height = 100;
            
            let columnsCount = 1;
            
            if(this.viewMode === "large"){
                this.serviceDiv.width = contentWidth / 2;
                columnsCount = 2;
            }
            
            this.servicesTable = [];
            
            let column = 1;
            
            let row = null;
            
            for(let i = 0; i < this.services.length; i++){
                
                let service = this.services[i];
                
                if(column > columnsCount){
                    column = 1;
                }
                if(column === 1){
                    row = [];
                    this.servicesTable.push(row);
                }
                row.push(service);
                
                column++;
                
            }
            
            
        },
        update: function(){
            
            this.serviceAdd({
                title: "1С:Обновление программ",
                description: "Получение обновлений прикладных решений (конфигураций) и технологической платформы, информации о планируемых релизах.",
                url: "https://portal.1c.ru/applications/4",
                img: {
                    src: "/img/1c/services/icon_1C-Program-update.png",
                    backgroundColor: "#93c64f"
                }
            });
            
            this.serviceAdd({
                title: "1С-Товары",
                description: "Прогноз спроса и автоматический заказ товаров. Анализ работы розничного магазина.",
                url: "https://portal.1c.ru/applications/57",
                img: {
                    src: "/img/1c/services/icon_1C-Goods.png",
                    backgroundColor: "#39b54a"
                }
            });
            
            this.serviceAdd({
                title: "1С:Бизнес-сеть. Торговая площадка",
                description: "Торговая площадка в программах «1С:Предприятие» для поставщиков и покупателей (закупщиков).",
                url: "https://portal.1c.ru/applications/60",
                img: {
                    src: "/img/1c/services/icon_1C-Bn-TradeOffers.png",
                    backgroundColor: "#ed2d24"
                }
            });
            
            this.serviceAdd({
                title: "1С:Контрагент",
                description: "Быстрая проверка информации о контрагентах, автоматическое заполнение реквизитов контрагентов в различных документах и другие полезные функции",
                url: "https://portal.1c.ru/applications/3",
                img: {
                    src: "/img/1c/services/icon_1C-Counteragent.png",
                    backgroundColor: "#b06fbe"
                }
            });
            
            this.serviceAdd({
                title: "1СПАРК Риски",
                description: "Оценка надежности и мониторинг контрагентов в программах 1С для принятия взвешенных решений о сотрудничестве и минимизации налоговых рисков.",
                url: "https://portal.1c.ru/applications/47",
                img: {
                    src: "/img/1c/services/icon_1C-Spark-risks.png",
                    backgroundColor: "#ee6a34"
                }
            });
            
            this.serviceAdd({
                title: "1С:Кабинет сотрудника",
                description: "Мобильное взаимодействие сотрудников и бухгалтерии по кадровым вопросам",
                url: "https://portal.1c.ru/applications/94",
                img: {
                    src: "/img/1c/services/icon_1C-ESS.png",
                    backgroundColor: "#337ab7"
                }
            });
            
            this.serviceAdd({
                title: "1С-ОФД",
                description: "<ul style='padding-left: 20px;'><li>&bull; онлайн-передача фискальных данных в ФНС и ЦРПТ (Маркировка)</li> <li>&bull; интеграция касс с программами 1С и аналитика по продажам</li><li>&bull; регистрация касс в ФНС, замена фискального накопителя и продление договора с ОФД</li></ul>",
                url: "https://portal.1c.ru/applications/56",
                img: {
                    src: "/img/1c/services/icon_1C-OFD.png",
                    backgroundColor: "#0159cc"
                }
            });
            
            this.serviceAdd({
                title: "1С-Отчетность",
                description: "Сдача регламентированной отчетности из программ 1С<ul style='padding-left: 20px;'><li>&bull; во все контролирующие органы: ФНС, ПФР, ФСС, Росстат, Росалкогольрегулирование, Росприроднадзор и ФТС</li> <li>&bull; без выгрузок и загрузок в другие программы</li></ul>",
                url: "https://portal.1c.ru/applications/5",
                img: {
                    src: "/img/1c/services/icon_1C-Reporting.png",
                    backgroundColor: "#c1272d"
                }
            });
            
            this.serviceAdd({
                title: "1С:Номенклатура",
                description: "Единый каталог описаний товаров в «1С:Предприятии 8».",
                url: "https://portal.1c.ru/applications/63",
                img: {
                    src: "/img/1c/services/icon_1C-Nomenclature.png",
                    backgroundColor: "#ed2d24"
                }
            });
            
            this.serviceAdd({
                title: "Линия консультаций",
                description: "Консультации специалистов Службы технической поддержки по «1С:Предприятию» и обслуживающего партнера по телефону и электронной почте.",
                url: "https://portal.1c.ru/applications/10",
                img: {
                    src: "/img/1c/services/icon_1C-Helpdesc.png",
                    backgroundColor: "#009245"
                }
            });
            
            this.serviceAdd({
                title: "Корпоративная технологическая поддержка",
                description: "Технологическая поддержка корпоративных клиентов. Повышение производительности, доступности и масштабируемости корпоративной информационной системы.",
                url: "https://portal.1c.ru/applications/80",
                img: {
                    src: "/img/1c/services/icon_1C-corp-support.png",
                    backgroundColor: "#037f7e"
                }
            });
            
            this.serviceAdd({
                title: "Информационная система 1С:ИТС",
                description: "<ul style='padding-left: 20px;'><li>&bull; практические рекомендации по ведению учета</li> <li>&bull; пошаговые инструкции по работе с программами 1С</li> <li>&bull; консультации специалистов</li><li>&bull; книги и бухгалтерские журналы</li></ul>",
                url: "https://portal.1c.ru/applications/7",
                img: {
                    src: "/img/1c/services/icon_1C-ITS.png",
                    backgroundColor: "#fbb03b"
                }
            });
            
            this.serviceAdd({
                title: "Отвечает аудитор",
                description: "Персональные письменные консультации от экспертов, аудиторов и методистов «1С» по вопросам бухгалтерского налогового и кадрового учета.",
                url: "https://portal.1c.ru/applications/11",
                img: {
                    src: "/img/1c/services/icon_1C-Auditor.png",
                    backgroundColor: "#f15a24"
                }
            });
            
            this.serviceAdd({
                title: "1С:Лекторий",
                description: "Регулярные семинары по законодательству и его отражению в программах «1С» – в очной форме и в формате видеолекций.",
                url: "https://portal.1c.ru/applications/13",
                img: {
                    src: "/img/1c/services/icon_1C-Lecture-hall.png",
                    backgroundColor: "#2e3192"
                }
            });
            
            this.serviceAdd({
                title: "1С:Облачный архив",
                description: "Надежная защита от потери учетных данных. Разработан специально для программ 1С.<br>Работает автоматически",
                url: "https://portal.1c.ru/applications/2",
                img: {
                    src: "/img/1c/services/icon_1C-Cloud-backup.png",
                    backgroundColor: "#29abe2"
                }
            });
            
            this.serviceAdd({
                title: "1С:Предприятие через Интернет (1С:Фреш)",
                description: "Работа с «1С:Бухгалтерией» и другими популярными программами 1С через интернет.",
                url: "https://portal.1c.ru/applications/9",
                img: {
                    src: "/img/1c/services/icon_1C-Enterprise.png",
                    backgroundColor: "#0071bc"
                }
            });
            
            this.serviceAdd({
                title: "1С:Подпись",
                description: "Электронная подпись для обмена юридически значимыми электронными документами или регистрации онлайн-касс в ФНС",
                url: "https://portal.1c.ru/applications/31",
                img: {
                    src: "/img/1c/services/icon_1C-Sign.png",
                    backgroundColor: "#a12851"
                }
            });
            
            this.serviceAdd({
                title: "1С:Линк",
                description: "Безопасный удаленный доступ через Интернет к программам 1С, установленным на вашем компьютере",
                url: "https://portal.1c.ru/applications/1",
                img: {
                    src: "/img/1c/services/icon_1C-Link.png",
                    backgroundColor: "#f7931e"
                }
            });
            
            this.serviceAdd({
                title: "1С-Такском",
                description: "Обмен электронными документами с контрагентами <ul style='padding-left: 20px;'><li>&bull; встроен в программы 1С – не нужны внешние платные обработки</li><li>&bull;  возможность обмена между 1С и другими программами</li><li>&bull;  входящие электронные документы бесплатно</li></ul>",
                url: "https://portal.1c.ru/applications/8",
                img: {
                    src: "/img/1c/services/icon_1C-Taxcom.png",
                    backgroundColor: "#662d91"
                }
            });
            
            this.serviceAdd({
                title: "1С-ЭДО",
                description: "Обмен электронными документами с контрагентами <ul style='padding-left: 20px;'><li>&bull; встроен в программы 1С – не нужны внешние платные обработки</li><li>&bull; возможность обмена между 1С и другими программами</li><li>&bull; через разных операторов (роуминг)</li><li>&bull; входящие электронные документы бесплатно</li></ul>",
                url: "https://portal.1c.ru/applications/30",
                img: {
                    src: "/img/1c/services/icon_1C-Edo.png",
                    backgroundColor: "#662d91"
                }
            });
            
            this.serviceAdd({
                title: "1С:КП Отраслевой",
                description: "Является тарифным планом 1С:Комплекта поддержки (далее – 1С:КП) и предоставляет на определенный срок право использования обновленных версий и релизов отраслевых или специализированных программ 1С.",
                url: "https://portal.1c.ru/applications/23",
                img: {
                    src: "/img/1c/services/icon_1C-Industry-subscription.png",
                    backgroundColor: "#8cc63f"
                }
            });
            
            this.serviceAdd({
                title: "ЭДО без электронной подписи для участников 1С:Бизнес-сеть",
                description: "Обмен электронными документами без электронной подписи между пользователями программ «1С».",
                url: "https://portal.1c.ru/applications/27",
                img: {
                    src: "/img/1c/services/icon_1C-Bn.png",
                    backgroundColor: "#ed2d24"
                }
            });
            
            this.serviceAdd({
                title: "1С-ЭТП",
                description: "Семейство продуктов для удобной работы на электронных торговых площадках, включая получение сертификата электронной подписи для ЭТП.",
                url: "https://portal.1c.ru/applications/42",
                img: {
                    src: "/img/1c/services/icon_1C-Etp.png",
                    backgroundColor: "#ed2d24"
                }
            });
            
            this.serviceAdd({
                title: "1С:Сверка",
                description: "Автоматическая сверка счетов-фактур с контрагентами непосредственно в программе 1С в любое удобное время – как в процессе ведения учета, так и перед отправкой декларации в ФНС.",
                url: "https://portal.1c.ru/applications/38",
                img: {
                    src: "/img/1c/services/icon_1C-Accounts-check.png",
                    backgroundColor: "#607c8a"
                }
            });
            
            this.serviceAdd({
                title: "1С:ДиректБанк",
                description: "Прямой обмен электронными документами с банком. Позволяет отправлять платежи в банк и получать выписки по расчетным счетам непосредственно из программ «1С», без переключения в систему «Клиент-банк».",
                url: "https://portal.1c.ru/applications/44",
                img: {
                    src: "/img/1c/services/icon_1C-Direct-bank.png",
                    backgroundColor: "#d53c2d"
                }
            });
            
            this.serviceAdd({
                title: "1С-Финконтроль",
                description: "Организация внутреннего контроля и автоматическая проверка ведения учета в казенных учреждениях и органах государственной власти, а также в бюджетных и автономных учреждениях.",
                url: "https://portal.1c.ru/applications/45",
                img: {
                    src: "/img/1c/services/icon_1C-Financial-control.png",
                    backgroundColor: "#2b427e"
                }
            });
            
            this.serviceAdd({
                title: "1С-Коннект",
                description: "Корпоративный чат с возможностью звонить, передавать файлы и удаленно подключаться к компьютеру. Оперативная поддержка пользователей программ 1С.",
                url: "https://portal.1c.ru/applications/12",
                img: {
                    src: "/img/1c/services/icon_1C-Buh-phone.png",
                    backgroundColor: "#14c4b7"
                }
            });
            
            this.serviceAdd({
                title: "1C-ABBYY Comparator",
                description: "Сравнение документов в текстовых и графических форматах в различных комбинациях, выявление значимых несоответствий, отчет о различиях.",
                url: "https://portal.1c.ru/applications/55",
                img: {
                    src: "/img/1c/services/icon_1С-ABBYY-Comparator.png",
                    backgroundColor: "#c60c30"
                }
            });
            
            this.serviceAdd({
                title: "1C-UMI",
                description: "Готовые сайты для всех типов бизнеса: для специалистов, компаний, а также лендинги и интернет-магазины.",
                url: "https://portal.1c.ru/applications/46",
                img: {
                    src: "/img/1c/services/icon_1C-UMI.png",
                    backgroundColor: "#007cc2"
                }
            });
            
            this.serviceAdd({
                title: "1С:Касса облачное приложение",
                description: "Учёт товаров, контроль продаж, встроенное рабочее место кассира, подключение внешних касс. Простая автоматизация одного или нескольких небольших магазинов или точек оказания услуг.",
                url: "https://portal.1c.ru/applications/86",
                img: {
                    src: "/img/1c/services/icon_1C-Kassa.png",
                    backgroundColor: "#FFC406"
                }
            });
            
            this.serviceAdd({
                title: "mag1c",
                description: "Автоматическое создание веб-витрины бизнеса из программы 1С для приема заказов или старта продаж через интернет.",
                url: "https://portal.1c.ru/applications/92",
                img: {
                    src: "/img/1c/services/icon_1C-MAG.png",
                    backgroundColor: "#1A5296"
                }
            });
            
        },
        serviceAdd(service){
            
            let id = this.services.length;
            
            service['id'] = id;
            
            this.services.push(service);
            
        },
        goToHref: function(href){
            this.$router.push(href);
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    
    
</style>

